import { useCallback, useRef } from "react";

export function useDebounce(callback: any, delay: number) {
  const timeoutRef: any = useRef(null);

  const debouncedFunction = useCallback(
    (...args: any) => {
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
      }
      timeoutRef.current = setTimeout(() => {
        callback(...args);
      }, delay);
    },
    [callback, delay],
  );

  return debouncedFunction;
}

export default useDebounce;
